import Axios from "axios";
import { SETTINGS } from "../properties/Settings";

export const EloMessageRepository = {
  getAll: (payload) => {
    return Axios({
      url: SETTINGS.API_URL + "eloMessage/getAll",
      method: "GET",
      params: payload,
    });
  },

  getAllWithoutPaging: () => {
    return Axios({
      url: SETTINGS.API_URL + "eloMessage/getAllWithoutPaging",
      method: "GET",
    });
  },

  create: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "eloMessage/create",
      method: "POST",
      data: data,
    });
  },

  update: (id, data) => {
    return Axios({
      url: SETTINGS.API_URL + `eloMessage/${id}`,
      method: "PUT",
      data: data,
    });
  },

  getById: (id) => {
    return Axios({
      url: SETTINGS.API_URL + `eloMessage/${id}`,
      method: "GET",
    });
  },

  delete: (id) => {
    return Axios({
      url: SETTINGS.API_URL + `eloMessage/${id}`,
      method: "DELETE",
    });
  },
  setRejected: (id) => {
    return Axios({
      url: SETTINGS.API_URL + `eloMessage/updateRejected/${id}`,
      method: "PUT",
    });
  },
  createDraftDeclaration: (data, organizationId) => {
    return Axios({
      url: `${SETTINGS.API_URL}eloMessage/saveDraft`,
      method: "POST",
      data: data,
      params: organizationId ? { organizationId } : {},
    });
  },
  updateDraftDeclaration: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}eloMessage/updateDraft`,
      method: "PUT",
      data: data,
    });
  },
  duplicate: (consignmentId) => {
    return Axios({
      url: `${SETTINGS.API_URL}eloMessage/duplicate/${consignmentId}`,
      method: "POST",
    });
  },
};
